// https://github.com/unicode-org/cldr/blob/master/common/supplemental/windowsZones.xml

import { ITimezone } from '../../reactCommons/model';

const Timezones: ITimezone[] = [
	{
		js: 'Pacific/Tongatapu',
		key: 'Tonga Standard Time',
		offset: 780,
		text: '(GMT +13:00) Tonga',
	},
	{
		js: 'Pacific/Auckland',
		key: 'New Zealand Standard Time',
		offset: 720,
		text: '(GMT +12:00) Auckland, Wellington, Fiji, Marshall Is., Kamchatka',
	},
	{
		js: 'Pacific/Guadalcanal',
		key: 'Central Pacific Standard Time',
		offset: 660,
		text: '(GMT +11:00) Solomon Is., New Caledonia, Magadan',
	},
	{
		js: 'Australia/Sydney',
		key: 'AUS Eastern Standard Time',
		offset: 600,
		text: '(GMT+10:00) Canberra, Melbourne, Sydney',
	},
	{
		js: 'Australia/Brisbane',
		key: 'E. Australia Standard Time',
		offset: 600,
		text: '(GMT+10:00) Brisbane, Lindeman',
	},
	{
		js: 'Pacific/Port_Moresby',
		key: 'West Pacific Standard Time',
		offset: 600,
		text: '(GMT+10:00) Guam, Port Moresby',
	},
	{
		js: 'Australia/Hobart',
		key: 'Tasmania Standard Time',
		offset: 600,
		text: '(GMT+10:00) Hobart',
	},
	{
		js: 'Asia/Vladivostok',
		key: 'Vladivostok Standard Time',
		offset: 600,
		text: '(GMT+10:00) Vladivostok',
	},
	{
		js: 'Australia/Darwin',
		key: 'AUS Central Standard Time',
		offset: 570,
		text: '(GMT +09:30) Darwin',
	},
	{
		js: 'Australia/Adelaide',
		key: 'Cen. Australia Standard Time',
		offset: 570,
		text: '(GMT +09:30) Adelaide',
	},
	{
		js: 'Asia/Yakutsk',
		key: 'Yakutsk Standard Time',
		offset: 540,
		text: '(GMT +09:00) Yakutsk',
	},
	{
		js: 'Asia/Seoul',
		key: 'Korea Standa rd Time',
		offset: 540,
		text: '(GMT +09:00) Seoul',
	},
	{
		js: 'Asia/Tokyo',
		key: 'Tokyo Standard Time',
		offset: 540,
		text: '(GMT +09:00) Osaka, Sapporo, Tokyo',
	},
	{
		js: 'Asia/Taipei',
		key: 'Taipei Standard Time',
		offset: 480,
		text: '(GMT +08:00) Taipei',
	},
	{
		js: 'Australia/Perth',
		key: 'W. Australia Standard Time',
		offset: 480,
		text: '(GMT +08:00) Perth',
	},
	{
		js: 'Asia/Singapore',
		key: 'Singapore Standard Time',
		offset: 480,
		text: '(GMT +08:00) Kuala Lumpur, Singapore',
	},
	{
		js: 'Asia/Irkutsk',
		key: 'North Asia East Standard Time',
		offset: 480,
		text: '(GMT +08:00) Irkutsk, Ulaan Bataar',
	},
	{
		js: 'Asia/Shanghai',
		key: 'China Standard Time',
		offset: 480,
		text: '(GMT +08:00) Beijing, Chongqing, Hong Kong, Urumqi',
	},
	{
		js: 'Asia/Krasnoyarsk',
		key: 'North Asia Standard Time',
		offset: 420,
		text: '(GMT +07:00) Krasnoyarsk',
	},
	{
		js: 'Asia/Bangkok',
		key: 'SE Asia Standard Time',
		offset: 420,
		text: '(GMT +07:00) Bangkok, Hanoi, Jakarta',
	},
	{
		js: 'Asia/Rangoon',
		key: 'Myanmar Standard Time',
		offset: 390,
		text: '(GMT +06:30) Rangoon',
	},
	{
		js: 'Asia/Novosibirsk',
		key: 'N. Central Asia Standard Time',
		offset: 360,
		text: '(GMT +06:00) Almaty, Novosibirsk',
	},
	{
		js: 'Asia/Almaty',
		key: 'Central Asia Standard Time',
		offset: 360,
		text: '(GMT +06:00) Astana, Dhaka',
	},
	{
		js: 'Asia/Katmandu',
		key: 'Nepal Standard Time',
		offset: 345,
		text: '(GMT +05:45) Kathmandu',
	},
	{
		js: 'Asia/Colombo',
		key: 'Sri Lanka Standard Time',
		offset: 330,
		text: '(GMT +05:30) Sri Jayawardenepura',
	},
	{
		js: 'Asia/Calcutta',
		key: 'India Standard Time',
		offset: 330,
		text: '(GMT +05:30) Chennai, Kolkata, Mumbai, New Delhi',
	},
	{
		js: 'Asia/Tashkent',
		key: 'West Asia Standard Time',
		offset: 300,
		text: '(GMT +05:00) Tashkent',
	},
	{
		js: 'Asia/Karachi',
		key: 'Pakistan Standard Time',
		offset: 300,
		text: '(GMT +05:00) Islamabad, Karachi',
	},
	{
		js: 'Asia/Yekaterinburg',
		key: 'Ekaterinburg Standard Time',
		offset: 300,
		text: '(GMT +05:00) Ekaterinburg',
	},
	{
		js: 'Asia/Kabul',
		key: 'Afghanistan Standard Time',
		offset: 270,
		text: '(GMT +04:30) Kabul',
	},
	{
		js: 'Asia/Yerevan',
		key: 'Caucasus Standard Time',
		offset: 240,
		text: '(GMT +04:00) Yerevan',
	},
	{
		js: 'Indian/Mauritius',
		key: 'Mauritius Standard Time',
		offset: 240,
		text: '(GMT +04:00) Port Louis',
	},
	{
		js: 'Asia/Baku',
		key: 'Azerbaijan Standard Time',
		offset: 240,
		text: '(GMT +04:00) Baku',
	},
	{
		js: 'Asia/Dubai',
		key: 'Arabian Standard Time',
		offset: 240,
		text: '(GMT +04:00) Abu Dhabi, Muscat',
	},
	{
		js: 'Asia/Tbilisi',
		key: 'Georgian Standard Time',
		offset: 240,
		text: '(GMT +04:00) Tbilisi',
	},
	{
		js: 'Asia/Tehran',
		key: 'Iran Standard Time',
		offset: 180,
		text: '(GMT +03:00) Tehran',
	},

	{
		js: 'Africa/Nairobi',
		key: 'E. Africa Standard Time',
		offset: 180,
		text: '(GMT +03:00) Nairobi',
	},
	{
		js: 'Europe/Moscow',
		key: 'Russian Standard Time',
		offset: 180,
		text: '(GMT +03:00) Moscow, St. Petersburg, Volgograd',
	},
	{
		js: 'Asia/Riyadh',
		key: 'Arab Standard Time',
		offset: 180,
		text: '(GMT +03:00) Kuwait, Riyadh',
	},
	{
		js: 'Asia/Baghdad',
		key: 'Arabic Standard Time',
		offset: 180,
		text: '(GMT +03:00) Baghdad',
	},
	{
		js: 'Africa/Windhoek',
		key: 'Namibia Standard Time',
		offset: 120,
		text: '(GMT +02:00) Windhoek',
	},
	{
		js: 'Europe/Chisinau',
		key: 'E. Europe Standard Time',
		offset: 120,
		text: '(GMT +02:00) Minsk',
	},
	{
		js: 'Asia/Jerusalem',
		key: 'Israel Standard Time',
		offset: 120,
		text: '(GMT +02:00) Jerusalem',
	},
	{
		js: 'Europe/Kiev',
		key: 'FLE Standard Time',
		offset: 120,
		text: '(GMT +02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
	},
	{
		js: 'Africa/Johannesburg',
		key: 'South Africa Standard Time',
		offset: 120,
		text: '(GMT +02:00) Harare, Pretoria',
	},
	{
		js: 'Africa/Cairo',
		key: 'Egypt Standard Time',
		offset: 120,
		text: '(GMT +02:00) Cairo',
	},
	{
		js: 'Asia/Beirut',
		key: 'Middle East Standard Time',
		offset: 120,
		text: '(GMT +02:00) Beirut',
	},
	{
		js: 'Europe/Bucharest',
		key: 'GTB Standard Time',
		offset: 120,
		text: '(GMT +02:00) Athens, Bucharest, Istanbul',
	},
	{
		js: 'Asia/Amman',
		key: 'Jordan Standard Time',
		offset: 120,
		text: '(GMT +02:00) Amman',
	},
	{
		js: 'Africa/Lagos',
		key: 'W. Central Africa Standard Time',
		offset: 60,
		text: '(GMT +01:00) West Central Africa',
	},
	{
		js: 'Europe/Paris',
		key: 'Romance Standard Time',
		offset: 60,
		text: '(GMT +01:00) Brussels, Copenhagen, Madrid, Paris',
	},
	{
		js: 'Europe/Budapest',
		key: 'Central European Standard Time',
		offset: 60,
		text: '(GMT +01:00) Sarajevo, Skopje, Warsaw, Zagreb',
	},
	{
		js: 'Europe/Budapest',
		key: 'Central European Standard Time',
		offset: 60,
		text: '(GMT +01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
	},
	{
		js: 'Europe/Berlin',
		key: 'W. Europe Standard Time',
		offset: 60,
		text: '(GMT +01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
	},
	{
		js: 'Atlantic/Reykjavik',
		key: 'Greenwich Standard Time',
		offset: -0,
		text: '(GMT) Monrovia, Reykjavik',
	},
	{
		js: 'Europe/London',
		key: 'GMT Standard Time',
		offset: -0,
		text: '(GMT) Dublin, Edinburgh, Lisbon, London',
	},
	{
		js: 'Africa/Casablanca',
		key: 'Morocco Standard Time',
		offset: -0,
		text: '(GMT) Casablanca',
	},
	{
		js: 'Atlantic/Azores',
		key: 'Azores Standard Time',
		offset: -60,
		text: '(GMT -01:00) Azores',
	},
	{
		js: 'Atlantic/Cape_Verde',
		key: 'Cape Verde Standard Time',
		offset: -60,
		text: '(GMT -01:00) Cape Verde Is.',
	},
	{
		js: 'America/Barbados',
		key: 'Mid-Atlantic Standard Time',
		offset: -120,
		text: '(GMT -02:00) Mid-Atlantic',
	},
	{
		js: 'America/Sao_Paulo',
		key: 'E. South America Standard Time',
		offset: -180,
		text: '(GMT -03:00) Brasilia',
	},
	{
		js: 'America/Buenos_Aires',
		key: 'Argentina Standard Time',
		offset: -180,
		text: '(GMT -03:00) Argentina',
	},
	{
		js: 'America/Cayenne',
		key: 'SA Eastern Standard Time',
		offset: -180,
		text: '(GMT -03:00) Georgetown',
	},
	{
		js: 'America/Godthab',
		key: 'Greenland Standard Time',
		offset: -180,
		text: '(GMT -03:00) Greenland',
	},
	{
		js: 'America/Montevideo',
		key: 'Montevideo Standard Time',
		offset: -180,
		text: '(GMT -03:00) Uruguay',
	},
	{
		js: 'America/St_Johns',
		key: 'Newfoundland Standard Time',
		offset: -210,
		text: '(GMT -03:30) Newfoundland',
	},
	{
		js: 'America/Halifax',
		key: 'Atlantic Standard Time',
		offset: -240,
		text: '(GMT -04:00) Atlantic Time (Canada)',
	},
	{
		js: 'America/La_Paz',
		key: 'SA Western Standard Time',
		offset: -240,
		text: '(GMT -04:00) La Paz',
	},
	{
		js: 'America/Cuiaba',
		key: 'Central Brazilian Standard Time',
		offset: -240,
		text: '(GMT -04:00) Manaus',
	},
	{
		js: 'America/Santiago',
		key: 'Pacific SA Standard Time',
		offset: -240,
		text: '(GMT -04:00) Santiago',
	},
	{
		js: 'America/Caracas',
		key: 'Venezuela Standard Time',
		offset: -270,
		text: '(GMT -04:30) Venezuela',
	},
	{
		js: 'America/Bogota',
		key: 'SA Pacific Standard Time',
		offset: -300,
		text: '(GMT -05:00) Bogota, Lima, Quito, Havana',
	},
	{
		js: 'America/Indianapolis',
		key: 'US Eastern Standard Time',
		offset: -300,
		text: '(GMT -05:00) Indiana (East)',
	},
	{
		js: 'America/New_York',
		key: 'Eastern Standard Time',
		offset: -300,
		text: '(GMT -05:00) Eastern Time (US & Canada)',
	},
	{
		js: 'America/Chicago',
		key: 'Central Standard Time',
		offset: -360,
		text: '(GMT -06:00) Central Time (US & Canada)',
	},
	{
		js: 'America/Cancun',
		key: 'Central Standard Time (Mexico)',
		offset: -360,
		text: '(GMT -06:00) Guadalajara, Mexico City, Monterrey',
	},
	{
		js: 'America/Regina',
		key: 'Canada Central Standard Time',
		offset: -360,
		text: '(GMT -06:00) Saskatcheewan',
	},
	{
		js: 'America/Phoenix',
		key: 'US Mountain Standard Time',
		offset: -420,
		text: '(GMT -07:00) Arizona',
	},
	{
		js: 'America/Chihuahua',
		key: 'Mountain Standard Time (Mexico)',
		offset: -420,
		text: '(GMT -07:00) Chihuahua, La Paz, Mazatlan',
	},
	{
		js: 'America/Phoenix',
		key: 'Mountain Standard Time',
		offset: -420,
		text: '(GMT -07:00) Mountain Time (US & Canada), Arizona, Chihuahua, La Paz, Mazatlan',
	},
	{
		js: 'America/Los_Angeles',
		key: 'Pacific Standard Time',
		offset: -480,
		text: '(GMT -08:00) Pacific Time (US & Canada)',
	},
	{
		js: 'America/Tijuana',
		key: 'Pacific Standard Time (Mexico)',
		offset: -480,
		text: '(GMT -08:00) Tijuana, Baja California',
	},
	{
		js: 'America/Anchorage',
		key: 'Alaskan Standard Time',
		offset: -540,
		text: '(GMT -09:00) Alaska',
	},
	{
		js: 'Pacific/Honolulu',
		key: 'Hawaiian Standard Time',
		offset: -600,
		text: '(GMT -10:00) Hawaii',
	},
	{
		js: 'Pacific/Apia',
		key: 'Samoa Standard Time',
		offset: -660,
		text: '(GMT -11:00) Midway Island, Samoa',
	},
	{
		js: 'Etc/GMT+12',
		key: 'Dateline Standard Time',
		offset: -720,
		text: '(GMT -12:00) International Date Line West',
	},
];

export default Timezones;
